import React from 'react';

const InputCelular = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const handlePaste = (event) => {
    let celularCopiado = event.clipboardData.getData('Text');

    if (celularCopiado.length <= 15) {
      celularCopiado = celularCopiado.replace(/\D/g, '');
    }
  };

  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9() -]/g, '');
  };

  const handleKeyDown = (e) => {
    let invalidChars = ['(', ')', ' ', '-'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }

    if (key !== 'Backspace' && key !== 'Delete') {
      var i = e.target.value.length;

      if (i === 0) e.target.value = e.target.value + '(';
      else if (i === 3) e.target.value = e.target.value + ') ';
      else if (i === 4) e.target.value = e.target.value + ' ';
      else if (i === 10) e.target.value = e.target.value + '-';
    }
  };

  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt campo-tel ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className="input-container input-com-ic">
        <i className="ic-celular input-ic"></i>

        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={className}
          maxLength="15"
          onInput={(e) => handleInput(e)}
          //onKeyDown={(e) => handleKeyDown(e)}
          onPaste={(e) => handlePaste(e)}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">
        {legenda} {msgErro}
      </div>
    </div>
  );
};

export default InputCelular;
